import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import type { SchemaQuotaEdit } from '@/__generated/es-api'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

const ERROR_UPDATE_QUOTA = 'Failed to update quota. Please try again.'

export const useUpdateQuota = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [update, result] = esApi.endpoints.updateOrgQuota.useMutation()

  const updateQuota = useCallback(
    async (quotaId: string, quota: SchemaQuotaEdit) => {
      if (!orgId) {
        return false
      }

      try {
        await update({
          orgId: orgId.toString(),
          quotaId,
          schemaQuotaEdit: quota,
        }).unwrap()
        dispatch(
          createNotification({
            'update-quota-success': {
              type: 'success',
              message: 'Quota was updated successfully.',
            },
          }),
        )

        return true
      } catch (error) {
        dispatch(
          createNotification({
            'update-quota-failure': {
              type: 'error',
              message: getErrorMessage(error, ERROR_UPDATE_QUOTA),
            },
          }),
        )

        return false
      }
    },
    [orgId, dispatch, update],
  )

  return [updateQuota, result] as const
}
